import { render, staticRenderFns } from "./ProjectsAndDevelopments.vue?vue&type=template&id=d372aa20&scoped=true"
import script from "./ProjectsAndDevelopments.vue?vue&type=script&lang=ts"
export * from "./ProjectsAndDevelopments.vue?vue&type=script&lang=ts"
import style0 from "./ProjectsAndDevelopments.vue?vue&type=style&index=0&id=d372aa20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d372aa20",
  null
  
)

export default component.exports